import { COLLECT_FEEDBACK_API } from "../config"

export const sendFeedback = async (type, message_id) => {
  const response = await fetch(COLLECT_FEEDBACK_API, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: type,
      message_id: message_id,}),
  });


  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return await response.json();
};

// Function to filter out boolean values from test data
const cleanFormDataForBackend = (formData) => {
  if (!formData || typeof formData !== 'object') {
    return formData;
  }

  const cleanedData = {};
  
  for (const [key, value] of Object.entries(formData)) {
    if (typeof value === 'boolean') {
      continue;
    }

    if (key.includes('Test') || 
        ['blanksim', 'msisdn', 'vobb', 'esim', 'fixedLine', 'softpin', 'prepaidstarterpack', 'reloadchargecard'].includes(key)) {
      continue;
    }

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      cleanedData[key] = cleanFormDataForBackend(value);
    } else {
      cleanedData[key] = value;
    }
  }
  
  return cleanedData;
};

export const createSRTicket = async (requesterData, formData, formId, formType, credentials = null) => {
  // Clean the form data to remove boolean values before sending to backend
  const cleanedFormData = cleanFormDataForBackend(formData);

  const payload = {
    data: {
      ...requesterData,
      form_id: formId,
      formType
    },
    formData: cleanedFormData
  };

  // Build API URL with credentials in dev mode
  let apiUrl = process.env.REACT_APP_CREATE_SR_TICKET_API;

  if (process.env.REACT_APP_MODE === 'dev' && credentials?.apiKey && credentials?.email) {
    const { buildRestApiUrl } = require('./urlBuilder');
    apiUrl = buildRestApiUrl(apiUrl, credentials.apiKey, credentials.email);
  }

  console.group('📡 HTTP Request - SR Ticket Creation');
  console.log('🔗 API Endpoint:', apiUrl);
  console.log('📋 Form ID:', formId);
  console.log('🏷️ Form Type:', formType);
  console.log('📦 Original Form Data:', formData);
  console.log('🧹 Cleaned Form Data (boolean values removed):', cleanedFormData);
  console.log('📦 Full Payload:', payload);
  console.log('📊 Payload Size:', JSON.stringify(payload).length, 'bytes');
  console.log('⏰ Sent At:', new Date().toISOString());
  console.groupEnd();

  const includeCredentials = process.env.REACT_APP_MODE === 'prod' ? 'include' : 'omit';

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    credentials: includeCredentials
  });

  console.log('✅ HTTP request sent successfully');
  console.log('📤 Response Status:', response.status);
  console.log('📥 Response Headers:', Object.fromEntries(response.headers.entries()));

  if (!response.ok) {
    const errorText = await response.text();
    console.error('❌ HTTP Error Response:', {
      status: response.status,
      statusText: response.statusText,
      body: errorText
    });

    // Try to parse error as JSON to get specific error messages
    let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    try {
      const errorData = JSON.parse(errorText);
      if (errorData.error && errorData.message) {
        // Use the specific error message from backend
        errorMessage = `${errorData.error}: ${errorData.message}`;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch (parseError) {
      // If JSON parsing fails, use the raw error text
      if (errorText) {
        errorMessage = `${errorMessage} - ${errorText}`;
      }
    }

    throw new Error(errorMessage);
  }

  const result = await response.json();
  console.log('📥 Success Response:', result);

  return result;
};